import TranscriptHeader from '../components/GeneratedTranscript/TranscriptHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import TranscriptText from '../components/GeneratedTranscript/TranscriptText';
import { Button } from 'components/ui/button';
import Player from '../components/GeneratedTranscript/Player';
import { downloadTranscript } from '../utils/transcriptUtils';

const GeneratedTranscript: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data } = location.state || {};
  const text = data.data.transcript?.text;
  const url = data.data.url;

  return (
    <div className="flex items-stretch gap-2">
      <div className="bg-background-main w-screen h-[calc(100vh-100px)] flex flex-col">
        {/* Header */}
        <div className="flex-none">
          <TranscriptHeader text={text} />
        </div>

        {/* Scrollable Text Container */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-[1200px] lg:py-9 p-4 lg:px-40 mx-auto lg:mb-9">
            {' '}
            {/* Removed mobile margin */}
            {text && <TranscriptText text={text} />}
          </div>
        </div>

        {/* Bottom Section - Mobile */}
        <div className="lg:hidden flex flex-col fixed bottom-0 left-0 right-0 bg-background-main">
          {/* Player */}
          <div className="bg-primary mx-4 rounded-lg h-[128px] mb-4 p-4">
            <Player url={url} />
          </div>

          {/* Action Buttons */}
          <div className=" border-t flex gap-4 p-4">
            <Button
              variant="customSecondary"
              className="flex-1 bg-secondary"
              onClick={() => navigate('/transcript')}
            >
              Discard
            </Button>
            <Button
              variant="customSecondary"
              className="flex-1 bg-secondary"
              onClick={() => text && downloadTranscript(text, 'transcript.txt')}
            >
              Export
            </Button>
          </div>
        </div>

        {/* Bottom Section - Desktop */}
        <div className="hidden lg:block flex-none">
          <div className="bg-primary px-8 rounded-lg h-[128px] w-full max-w-[1200px] mx-auto">
            <Player url={url} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratedTranscript;
